// @ts-nocheck
import * as currentUser from './currentUser';

export function recordRevenue(value) {
    const user = currentUser.get();
    if (!TRPCONFIG.Domain.VWOTestingEnabled || !!(user && user.Agent)) {
        return;
    }

    // eslint-disable-next-line camelcase
    window._vis_opt_queue = window._vis_opt_queue || [];
    /* global _vis_opt_revenue_conversion: false */
    window._vis_opt_queue.push(function() { _vis_opt_revenue_conversion(value); });
}

export function registerConversion(goalId, testId) {
    const user = currentUser.get();
    if (!TRPCONFIG.Domain.VWOTestingEnabled || !!(user && user.Agent)) {
        return;
    }

    // eslint-disable-next-line camelcase
    window._vis_opt_queue = window._vis_opt_queue || [];
    /* global _vis_opt_register_conversion: false */
    window._vis_opt_queue.push(function() { _vis_opt_register_conversion(goalId, testId); });
}

/* eslint-disable */ //some dodgy JS from VWO, way too many issues with eslint so just ignoring it
export function executeTrackingCode(hide) {
    const user = currentUser.get();
    if (!TRPCONFIG.Domain.VWOTestingEnabled || !!(user && user.Agent)) {
        return;
    }

    const $ = window.vwo_$ || window.$ || window.jQuery;
    $ && $('.vwo_loaded').removeClass('vwo_loaded');
    if (window._vwo_code) {
        return;
    }
    window._vwo_code = (function() {
        const account_id = TRPCONFIG.Domain.VWOAccountId;
        const settings_tolerance = 2000;
        const library_tolerance = 2500;
        const url = window._vis_opt_url || document.URL;
        const use_existing_jquery = true;
        // DO NOT EDIT BELOW THIS LINE
        const d = document;
        let f = false;
        let mpTimeout = null;
        return {
            use_existing_jquery: function() { return use_existing_jquery; },
            library_tolerance: function() { return library_tolerance; },
            finish: function () {
                if (!f) {
                    f = true;
                    const a = d.getElementById('_vis_opt_path_hides');
                    if (a) a.parentNode.removeChild(a);
                }

                clearTimeout(mpTimeout);
                mpTimeout = setTimeout(this.pushToMixpanel, 500);
            },
            finished: function() { return f; },
            load: function(a) {
                const b = d.createElement('script');
                b.src = a;
                b.type = 'text/javascript';
                b.innerText;
                b.onerror = function() { _vwo_code.finish(); };
                d.getElementsByTagName('head')[0].appendChild(b);
            },
            init: function() {
                const settings_timer = setTimeout('_vwo_code.finish()', settings_tolerance);
                this.load('//dev.visualwebsiteoptimizer.com/j.php?a=' + account_id + '&u=' + encodeURIComponent(url) + '&r=' + Math.random());

                //DK: have seen issues in dev where the style is added multiple times (bad code, but we want to avoid this in live)
                //so have added a check for the style before adding it again. Users won't get stuck with a blank white screen.
                if (TRPCONFIG.Domain.VWOShowOverlay){
                    if (!d.getElementById('_vis_opt_path_hides')) {
                        const a = d.createElement('style'),
                            b = hide ? hide + '{filter:contrast(50%) !important; -webkit-filter:contrast(50%) !important; opacity:0.55 !important;filter:alpha(opacity=0.55) !important;background:none !important; pointer-events: none !important;}' : '',
                            h = d.getElementsByTagName('head')[0];
                        a.setAttribute('id', '_vis_opt_path_hides');
                        a.setAttribute('type', 'text/css');
                        if (a.styleSheet) a.styleSheet.cssText = b;
                        else a.appendChild(d.createTextNode(b));
                        h.appendChild(a);
                    }
                }

                return settings_timer;
            },
            pushToMixpanel: function() {
                let _vis_opt_queue = window._vis_opt_queue || [], _vis_counter = 0, mixpanel = window.mixpanel;
                if (mixpanel) {
                    _vis_opt_queue.push(function () {
                        try {
                            if (!_vis_counter) {
                                var _vis_data = {}, _vis_combination, _vis_id, _vis_l = 0;
                                for (; _vis_l < _vwo_exp_ids.length; _vis_l++) {
                                    _vis_id = _vwo_exp_ids[_vis_l];
                                    if (_vwo_exp[_vis_id].ready) {
                                        _vis_combination = _vis_opt_readCookie('_vis_opt_exp_' + _vis_id + '_combi');
                                        if (typeof(_vwo_exp[_vis_id].combination_chosen) != "undefined")
                                            _vis_combination = _vwo_exp[_vis_id].combination_chosen;
                                        if (typeof(_vwo_exp[_vis_id].comb_n[_vis_combination]) != "undefined") {
                                            _vis_data['VWO-Test-ID-' + _vis_id] = _vwo_exp[_vis_id].comb_n[_vis_combination];
                                            _vis_counter++;
                                        }
                                    }
                                }
                                // Use the _vis_data object created above to fetch the data,
                                // key of the object is the Test ID and the value is Variation Name
                                if (_vis_counter) {
                                    mixpanel.register_once(_vis_data);
                                }
                            }
                        }
                        catch (err) {
                        }
                    });
                }
            }
        };
    }());
    window._vwo_settings_timer = _vwo_code.init();
}
/* eslint-enable */

export function progressiveHotelSearchEnabled(isHotel) {
    // When this ab-test is unpicked, then will need to decide if it should still be hotel only,
    // and what is the best way to detect that.

    if (!TRPCONFIG.Domain.ProgressiveHotelSearchEnabled || window.location.pathname.indexOf('holiday') > -1) {
        return false;
    }
    return isHotel || window.location.pathname.indexOf('hotel') > -1;
}
